import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/store";
import { fetchCurrentUser } from "@/store/authSlice";
import { LoadingScreen } from "@/components/LoadingScreen";

export function CallbackPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, loading } = useAppSelector((s) => s.auth);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    if (loading) return;

    if (isAuthenticated && user) {
      const emailPrefix = user.email
        .split("@")[0]
        .replace(/[^a-zA-Z0-9_]/g, "_");
      if (user.username === emailPrefix.substring(0, 20)) {
        navigate("/postavi-ime", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } else {
      navigate("/", { replace: true });
    }
  }, [loading, isAuthenticated, user, navigate]);

  return <LoadingScreen />;
}
